<div class="NotificationDiv DataInfo" *ngIf="data.info">
    <div class="bar">
        <div class="in"></div>
    </div>
    <div class="NotiContect">
        <div class="TextDesc">
            <div><i class="fa-solid fa-circle-info"></i></div>
            <div>
                <h3>{{ data.title }}</h3>
                <p [innerHTML]="data.message"></p>
            </div>
        </div>
        <div id="btnClose1" mat-icon-button color="basic" class="snackbar-close" (click)="snackBar.dismiss()"><i
                class="fa-solid fa-xmark"></i></div>
    </div>
</div>

<div class="NotificationDiv DataWarning" *ngIf="data.warn">
    <div class="bar">
        <div class="in"></div>
    </div>
    <div class="NotiContect">
        <div class="TextDesc">
            <div><i class="fa-solid fa-triangle-exclamation"></i></div>
            <div>
                <h3>{{ data.title }}</h3>
                <p [innerHTML]="data.message"></p>
            </div>
        </div>
        <div id="btnClose2" mat-icon-button color="basic" class="snackbar-close" (click)="snackBar.dismiss()"><i
                class="fa-solid fa-xmark"></i></div>
    </div>
</div>

<div class="NotificationDiv DataError" *ngIf="data.err">
    <div class="bar">
        <div class="in"></div>
    </div>
    <div class="NotiContect">
        <div class="TextDesc">
            <div><i class="fa-solid fa-circle-exclamation"></i></div>
            <div>
                <h3>{{ data.title }}</h3>
                <p [innerHTML]="data.message"></p>
            </div>
        </div>
        <div id="btnClose3" mat-icon-button color="basic" class="snackbar-close" (click)="snackBar.dismiss()"><i
                class="fa-solid fa-xmark"></i></div>
    </div>
</div>

<div class="NotificationDiv DataSuccess" *ngIf="data.Success">
    <div class="bar">
        <div class="in"></div>
    </div>
    <div class="NotiContect">
        <div class="TextDesc">
            <div><i class="fa-solid fa-circle-check"></i></div>
            <div>
                <h3>{{ data.title }}</h3>
                <p [innerHTML]="data.message"></p>
            </div>
        </div>
        <div id="btnClose4" mat-icon-button color="basic" class="snackbar-close" (click)="snackBar.dismiss()"><i
                class="fa-solid fa-xmark"></i></div>
    </div>
</div>